import backofficeApi from './backoffice-api';

const CHARGES_PATH = '/catering/packaging/charges';
const FEATURES_PATH = '/catering/packaging/features';
const BACKOFFICE_TOKEN_KEY = 'token_backoffice';
const BEARER_PREFIX = 'Bearer ';
const UNAUTHORIZED_STATUS = 401;
const FORBIDDEN_STATUS = 403;
const MISSING_SESSION_MESSAGE = 'The backoffice session token is missing or no longer valid';
const NOT_AVAILABLE_MESSAGE = 'The supplies charges module is turned off for the kitchen country';

export const MISSING_SESSION_CODE = 'missing_backoffice_session';
export const CHARGES_NOT_AVAILABLE_CODE = 'packaging_charges_not_available';

function readBackofficeToken() {
  return window.localStorage.getItem(BACKOFFICE_TOKEN_KEY) || '';
}

function codedError(message, code) {
  const error = new Error(message);
  error.code = code;
  return error;
}

function missingSessionError() {
  return codedError(MISSING_SESSION_MESSAGE, MISSING_SESSION_CODE);
}

function responseStatus(requestError) {
  return requestError.response ? requestError.response.status : null;
}

function translateRequestError(requestError) {
  const status = responseStatus(requestError);
  if (status === UNAUTHORIZED_STATUS) return missingSessionError();
  if (status === FORBIDDEN_STATUS) return codedError(NOT_AVAILABLE_MESSAGE, CHARGES_NOT_AVAILABLE_CODE);
  return requestError;
}

function getWithBackofficeSession(path) {
  const token = readBackofficeToken();
  if (!token) return Promise.reject(missingSessionError());

  return backofficeApi
    .get(path, { headers: { Authorization: BEARER_PREFIX + token } })
    .then(({ data }) => data.data)
    .catch((requestError) => Promise.reject(translateRequestError(requestError)));
}

export default {
  fetchCharges() {
    return getWithBackofficeSession(CHARGES_PATH);
  },
  fetchPackagingFeatures() {
    return getWithBackofficeSession(FEATURES_PATH);
  },
};
